<template>
  <div class="placement">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="color: #fff;">
        <use xlink:href="#icon-a-PaidPlacement"></use>
       
      </svg>
    </breadcrumbs>
    <div class="content-wrapper">
      <div class="table-head">
        <a-space>
          <ButtonGroups 
          :pagination="{
            total: pagination.total,
            page: pagination.page,
            size: pagination.size,
          }"
                :tableData="dataSource"
                 @pageChange="onPageChange" />
        </a-space>

        <a-space class="filters">
          <a-input-search v-model:value="queryParams.keyword" :placeholder="st('common.searchPlaceholder')" allow-clear @search="onSearch"
            @pressEnter="onSearch">
          </a-input-search>
        </a-space>
      </div>
      <div class="filterBar" ref="marketplaceRef">
        <div class="filterBar-content">
          <div class="mid-filter-item">
            <div class="mid-filter-title">{{ st('placement.linkTypeFilter') }}</div>
            <div class="mid-filter-checkbox">
              <a-checkbox v-model:checked="queryParams.attribution" >Attribution</a-checkbox>
              <a-checkbox v-model:checked="queryParams.associate"
                class="upcoming-box">Associate</a-checkbox>
            </div>
          </div>
          <div class="mid-filter-item" ref="operationRef">
            <div class="mid-filter-title">{{ st('placement.sort') }}</div>
            <artmisads-select
          v-model:value="queryParams.priceSort"
          style="width: 180px"
         
          :getPopupContainer="() => operationRef"
        >
          <a-select-option value="asc">
            <Icon name="paixu1" class="iconAsc paixuIcon"/>
             <span class="paixuText">{{ st('placement.sortByPrice') }}</span>  
          </a-select-option>
          <a-select-option value="desc" class="paixuIcon">
            <Icon name="paixu1"/>
             <span class="paixuText">{{ st('placement.sortByPrice') }}</span> 
          </a-select-option>
        
        </artmisads-select>
          </div>
        </div>
      </div>
      <div class="table">
        <artmisads-table :columns="columns" :data-source="dataSource" 
        :loading="loading"
        :scroll="{ x:2600,y: tableScrollHeight }"
        :pagination="{
          total: pagination.total,
          pageSize: pagination.size,
          current: pagination.page,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100', '200']
        }" :change="onChangePage">
        <template #bodyCell="{ column, text, index, record }">
          <template v-if="column.name === 'publisher'">
            <div class="publisher-info">
              <LogoImage :logoUrl="record.publisher.publicImage" :brandName="record.publisher.creatorName" />
              <AutoTooltip :content="record.publisher.creatorName" :width="120" />
            </div>
           
          </template>
          <template v-if="column.name === 'name'">
            <AutoTooltip :content="record.name" :width="180" />
          </template>
          <template v-if="column.name === 'price'">
            {{ CURRENCY_DATA_MAPPER[record.currency] }} {{ record.price.toFixed(2) }}
          </template>
          <template v-if="column.name === 'durationDays'">
            {{ record.durationDays ? st('placement.durationDays', { n: record.durationDays }) : '-' }}
          </template>
          <template v-if="column.name === 'availableResultTypes'">
            <div>
              <div v-for="item in record.availableResultTypes" :key="item">
                <a-badge color="blue" :text="item" />
              </div>
            </div>
            
          </template>
          <template v-if="column.name === 'linkType'">
            <div class="linkType">
              <img src="../../../../assets/images/img/AS@2x.png" alt="" class="iconlinkType" v-if="record.linkType === 'associate'">
            <img src="../../../../assets/images/img/AT@2x.png" alt="" class="iconlinkType" v-if="record.linkType === 'attribution'">
            <span class="linkTypeText">{{ linkTypeLabel(record.linkType) }}</span>
            </div>
            
          </template>
          <template v-if="column.name === 'availableFrom'">
            {{ record.availableFrom? setTime(record.availableFrom) : '-' }}
          </template>
          <template v-if="column.name === 'example'">
            <div>
              <div v-for="item in record.exampleFiles" :key="item.id">
                <div v-if="isImage(item.originalFileName)"  style="margin: 4px 0;">
                  <a-image :src="item.url" alt="" width='100px' :placeholder="true" 
                  height='50px'/>
                </div>
               
                <div v-else style="margin: 4px 0;">
                 {{ item.originalFileName }} 
                </div>
              </div>
            </div>
          </template>
          <template v-if="column.name === 'action'">
            <artmisads-select-button size="small" @click="viewPlacement(record.id)">{{ st('placement.view') }}</artmisads-select-button>
            <artmisads-select-button size="small" @click="applyPlacement(record)" style="margin-left: 8px;">{{ st('placement.apply') }}</artmisads-select-button>
           
          </template>
        </template>
      </artmisads-table>
      </div>
      <ApplicationModel ref="applicationModelRef" @refresh="refresh" />
      <a-modal v-model:open="open" title="" :footer="null" :mask="false" :maskClosable="false" width="700px">
        <div>
        <div class="success-text-box">
          <svg-icon name="success-tianchong" style="width: 24px;height: 24px;color: #80C026;font-size: 24px;"/>
          <p class="success-text">{{ st('placement.successTitle') }}</p>
        </div>
        <p class="success-text mg-16 ml-24">{{ st('placement.successBodyBefore') }}<span class="font-bolder">{{ st('placement.successBodyPath') }}</span></p> 
        <div style="margin-left: 34px;margin-top: 10px;">
          <artmisads-select-button  type="primary" @click="goToCampaigns">{{ st('placement.goToCampaigns') }}</artmisads-select-button>
        </div>
      </div>
    </a-modal>
    </div>
  </div>
</template>

<script setup>
import breadcrumbs from '@/components/breadcrumbs.vue'
import ButtonGroups from '@/components/buttonGroups.vue'
import { sellerPlacementApi } from '~/server/index'
import AutoTooltip from '@/components/AutoTooltip.vue'
import LogoImage from '@/components/LogoImage.vue'
import { CURRENCY_DATA_MAPPER } from '~/contants/common'
import { useRouter } from 'vue-router'
import ApplicationModel from './applicationModel.vue'
import { ref, watch, computed } from 'vue'
import Icon from "@/components/Icon.vue";
import { useSellerI18n } from '@/composables/useSellerI18n'
import SvgIcon from '~/components/SvgIcon.vue';
import { setTime } from '~/utils'
import { useTableScrollHeight } from "@/utils/useTableScrollHeight";
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 280,
  minHeight: 200,
  maxHeight:1000,
  defaultHeight: 350
});
const { st } = useSellerI18n()

const linkTypeLabel = (type) => {
  if (type === 'associate') return 'Associate'
  if (type === 'attribution') return 'Attribution'
  return type || ''
}

const open=ref(false)
const loading = ref(false)
const marketplaceRef = ref(null)
const operationRef = ref(null)
const router = useRouter()
const applicationModelRef = ref(null)
const queryParams = ref({
  keyword: '',
  status: '',
  attribution:false,
  associate:false,
  priceSort:'asc'
})
const columns = computed(() => [
  {
    title: st('placement.colPublisher'),
    dataIndex: 'publisher',
    name: 'publisher',
    width: 200,
  },
  {
    title: st('placement.colPlacementName'),
    dataIndex: 'name',
    name: 'name',
    width: 200,
  },
  {
    title: st('placement.colPrice'),
    dataIndex: 'price',
    name: 'price',
    width: 200,
  },
  {
    title: st('placement.colDescription'),
    dataIndex: 'description',
    name: 'description',
    width: 350,
  },
  {
    title: st('placement.colSpecs'),
    dataIndex: 'specifications',
    name:'specifications',
    width: 350,
  },
  {
    title: st('placement.colDuration'),
    dataIndex: 'durationDays',
    name:'durationDays'
  },
  {
    title: st('placement.colInventory'),
    dataIndex: 'availableInventory',
  },
  {
    title: st('placement.colLinkType'),
    dataIndex: 'linkType',
    name:'linkType',
  },
  {
    title: st('placement.colMaxAsins'),
    dataIndex: 'maxAsinCount',
  },
  {
    title: st('placement.colAvailableResults'),
    dataIndex: 'availableResultTypes',
    name:'availableResultTypes',
  },
  {
    title: st('placement.colAvailableFrom'),
    dataIndex: 'availableFrom',
    name:'availableFrom',
  },
  {
    title: st('placement.colExample'),
    dataIndex: 'example',
    name:'example',
  },
  {
    title: st('placement.colAction'),
    name: 'action',
    fixed: 'right',
    textAlign: 'center',
    width: 200,
  },
])
watch(queryParams, () => {
  pagination.value.page = 1
  pagination.value.size = 10
  getList()
},{
  deep: true,
  immediate: false,
})
const dataSource = ref([])
const pagination = ref({
  total: 30,
  defaultPageSize: 10,
  size: 10,
  page: 1,
  showSizeChanger: true,

})
const breadcrumbsData = computed(() => ({
  title: st('placement.pageTitle'),
  des: st('placement.pageDes'),
  color: '#80C026',
  links: [
    {
      name: st('common.home'),
      path: "/seller/dashboard",
    },
    {
      name: st('placement.breadcrumbPaidPlacements'),
      path: "/seller/Settings/paidPlacement/placement",
    },
    {
      name: st('placement.pageTitle'),
      path: "/seller/Settings/paidPlacement/placement",
    },
  ],
}))
const onPageChange = (page) => {

  pagination.value.page = page

  getList()

}
const onChangePage = (data) => {
  const { current, pageSize } = data

  pagination.value.page = current
  


  pagination.value.size = pageSize
  getList()
} 
const isImage = (url) => {
  if(!url) return 
  return url.includes('.jpg') || url.includes('.jpeg') || url.includes('.png')
}
const onSearch = () => {
  pagination.value.page = 1
  pagination.value.size = 10
  getList()
}

const goToCampaigns=()=>{
  router.push('/seller/Settings/paidPlacement/campaigns')
}
const refresh=()=>{
  open.value = true
  getList()
}
const getList = () => {
  loading.value = true

  const params = {
    ...queryParams.value,
    ...pagination.value,
  }
  // 处理 attribution 和 associate 参数逻辑
  const { attribution, associate } = queryParams.value;
  
  // 删除原始参数，避免重复传递
  delete params.attribution;
  delete params.associate;
  
  // 根据参数值设置 linkType
  if (attribution && associate) {
    // 两个都选中时，不设置 linkType（或者可以根据业务需求设置默认值）
  } else if (attribution) {
    params.linkType = 'attribution';
  } else if (associate) {
    params.linkType = 'associate';
  }
  // 两个都不选中时，不设置 linkType
  
  sellerPlacementApi.getPlacement(params).then(res => {
    dataSource.value = res.data.data
    pagination.value.total = res.data.total
  }).finally(() => {
    loading.value = false
  })
}
const viewPlacement = (id) => {
  router.push(`/seller/Settings/paidPlacement/placement/${id}`)
}
const applyPlacement = (item) => {

  applicationModelRef.value.handleOpen(item.id,item.maxAsinCount)
}
// setTimeout(() => {
//   applicationModelRef.value.handleOpen()
// }, 1000)
getList()
</script>

<style scoped lang="less">
.success-text-box{
  display: flex;
  align-items: center;
  gap: 10px;
}
.ml-24{
  margin-left: 34px !important;
}
.mg-16{
  margin: 5px 0;
}
.success-text{
  color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.3px;
      opacity: 0.7;
      width: 660px;
}
.link-text{
   text-decoration: underline;
}
.font-bolder{
  font-weight: 600;
}
.iconAsc{
  transform: rotate(180deg);
}
.paixuText{
  margin-left: 4px;
}
.iconlinkType{
  width: 24px !important;
  height: 24px !important;
}
.linkType{
  display: flex;
  align-items: center;
  gap: 5px;
}
.placement {
  padding: 16px;
  padding-top: unset;
  width: 100%;
 .publisher-info{
  display: flex;
  align-items: center;
  gap: 10px;
 }
  .content-wrapper {
    display: block !important;
    background-color: #fff;
    padding: 16px;
    .table-head {
      display: flex;
      align-items: center;
      gap: 16px;
    }
  }
  .mid-filter{
    display: flex;
    align-items: space-between;
    position: relative;
    margin-bottom: 16px;
    margin-top: 16px;
    // justify-content: space-between;
    padding: 16px;
    padding-right: 96px;
    border-radius: 8px;
    background-color: var(--bg-gray-1);
    flex-wrap: wrap;
    gap: 16px; // 垂直和水平间距都是16px
    // overflow: hidden;
    max-height: 86px; // 限制为一行的高度，不包括gap，因为第一行不会有gap
    transition: max-height 0.3s ease;
    
   
  &-item {
    display: flex;
    flex-direction: column;
    // width: 20%;
    
    &.filter-item-hidden {
      display: none !important;
    }
  }

  &-checkbox {
    background-color: var(--bg-gray-6);
    border-radius: 8px;
    height: 32px;
    padding: 0 8px;
    display: flex;
    align-items: center;
    // justify-content: center;
  }

  &-title {
    font-size: 13px;
    font-weight: 600;
    height: 18px;
    // opacity: 0.7;
    letter-spacing: 0.3px;
    line-height: 18px;
    color: #0F0629;
    margin-bottom: 4px;
  }
  }
  .filterBar {
    width: 100%;
    padding: 16px;
    display: flex;
    border-radius: 8px;
    margin-top: 16px;
    align-items: center;
    background: #f8f7fc;
    justify-content: space-between;

    .filterBar-content {
      gap: 16px;
      display: flex;

      .item {
        display: flex;
        flex-direction: column;

        >span {
          color: var(--dark-2);
          font-weight: 500;
          font-size: 13px;
          letter-spacing: 0.3px;
          line-height: 18px;
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>